import { useCallback, useEffect, useState } from 'react';
import { getCreditsStatus } from '../api';
import type { CreditsStatus } from '../types/db';
import { useClientId } from './useClient';

/**
 * Carica e mantiene aggiornato il saldo crediti + cap testate del client
 * loggato (vista v_client_credits_status). Sprint Pricing v0.
 *
 * Espone `refresh()` per ricaricare dopo una generazione o l'arrivo di
 * un nuovo pagamento (ricaricabile manualmente; nessun realtime in v0).
 */
export function useCredits(): {
  credits: CreditsStatus | null;
  loading: boolean;
  error: string | null;
  refresh: () => Promise<void>;
} {
  const clientId = useClientId();
  const [credits, setCredits] = useState<CreditsStatus | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    try {
      setError(null);
      const c = await getCreditsStatus(clientId);
      setCredits(c);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Errore caricamento crediti');
    } finally {
      setLoading(false);
    }
  }, [clientId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { credits, loading, error, refresh };
}
